import ErroredKioskNotificationsContainer from './errored-kiosk-notifications-container';

export default ErroredKioskNotificationsContainer;
